export default __webpack_public_path__ + "locales/sl/Settings.json?hash=781c314a24740711a89ea765c69ead2a";